<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" class="play-button">
    <circle cx="41" cy="41" r="37" stroke="#fff" stroke-width="1"></circle>
    <polygon
      fill="none"
      stroke="#fff"
      stroke-width="1"
      points="32,25 32,58 60,42"
    ></polygon>
  </svg>
</template>

<script>
  export default {
    name: 'PlayButton',
    props: {},
  };
</script>

<style lang="scss" scoped></style>
